import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import EmployeeFunctionalRoleModel from '../../../models/EmployeeFunctionalRoleModel';
import DataService from "../../../services/data.service";
import AddEmployeePopup from '../Popups/FunctionalRole_popup_AddEmployee';

interface Props {
    functionalRoleId: number
}

const FunctionalRole_tab_Employees: React.FC<Props> = ({ functionalRoleId }) => {
    const [data, setData] = useState<EmployeeFunctionalRoleModel[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();

    useEffect(() => {
        getTableData();
    }, [functionalRoleId]);

    function getTableData() {
        DataService.get<EmployeeFunctionalRoleModel[]>('api/v1/EmployeeFunctionalRoles/ByFunctionalRole/' + functionalRoleId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/EmployeeFunctionalRoles/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'employeeId', visible: false },
        { title: 'Employee', dataProp: 'employee.name' },
    ];

    if (isAuthorizedFor(ApplicationFunctions.EditFunctionalRoleForEmployee)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            }
        );
    }

    return (
        <>
            <DataTable
                name='dtApplicationRoleEmployees'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Employee'
                navigateUrl='/plm/UserManagement/Employee/'
            />
            {showPopup && (<AddEmployeePopup functionalRoleId={functionalRoleId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />)}

        </>
    );
}
export default FunctionalRole_tab_Employees;